export const STATUS_COLORS = {
  success: {bg: "#dcfce7", text: "#15803d"},
  warning: {bg: "#fef9c3", text: "#a16207"},
  error: {bg: "#fef2f2", text: "#dc2626"},
  info: {bg: "#eff6ff", text: "#1d4ed8"},
};
